import { useEffect, useState } from 'react';
import {
	Sidebar,
	Menu,
	MenuItem,
	SubMenu,
	useProSidebar,
} from 'react-pro-sidebar';
import logo from '../../img/logobordado.png';
import './Sidebar.css';
import { filteredModules } from './SidebarItems';
import { Link } from 'react-router-dom';
import { FiLogOut } from 'react-icons/fi';
import { RiLockPasswordFill } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import { AiOutlineDoubleLeft, AiOutlineDoubleRight } from 'react-icons/ai';
import { ClipLoader } from 'react-spinners';
import { getUserByEmail } from '../../api/usersModule/getters';
import { useNotificationsContext } from '../../utils/Contexts/NotificationsContext';

const CollapsibleSidebar = ({ user, signOut }) => {
	const [selectedMenuItem, setSelectedMenuItem] = useState(null);
	const [selectedSubMenu, setSelectedSubMenu] = useState(null);
	const [selectedMenu, setSelectedMenu] = useState(null);
	const { collapseSidebar, collapsed } = useProSidebar();
	const navigate = useNavigate();
	const [modules, setModules] = useState([]);
	const [loading, setLoading] = useState(true);
	const [userObject, setUserObject] = useState({
		UserName: '',
	});
	const ntfs = useNotificationsContext();
	const [numberUnseen, setNumberUnseen] = useState(ntfs.getNumberUnseenNotifications());

	useEffect(() => {
		const unseenObserver = (number) => {
			setNumberUnseen(number);
		};
		ntfs.addObserver('numberUnseen', unseenObserver);
		return () => {
			ntfs.removeObserver('numberUnseen', unseenObserver);
		};
	}, []);

	useEffect(() => {
		getUserByEmail(
			user.attributes.email,
			setUserObject,
			user.attributes['custom:project']
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const getCapitalizedString = (string) => {
		return string.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
	};


	const getFilteredModules = async () => {
		setLoading(true);
		await filteredModules(user, setModules);
		setLoading(false);
	};

	useEffect(() => {
		getFilteredModules();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user]);

	const MODE = 'default';

	let BACKGROUND_COLOR = '#146284'; //84ccec
	let SUB_MENU_ITEM_BG_COLOR = '#0D5173';
	let TEXT_COLOR = '#f0f0f0';
	let TEXT_COLOR_HOVER = '#000';

	switch (MODE) {
		case 'mode1':
			BACKGROUND_COLOR = '#1a1a1a';
			SUB_MENU_ITEM_BG_COLOR = '#222222';
			TEXT_COLOR = '#f0f0f0';
			TEXT_COLOR_HOVER = '#000';
			break;
		case 'mode2':
			BACKGROUND_COLOR = '#264653';
			SUB_MENU_ITEM_BG_COLOR = '#335D70';
			TEXT_COLOR = '#f0f0f0';
			TEXT_COLOR_HOVER = '#000';
			break;
		case 'mode3':
			BACKGROUND_COLOR = '#2c3e50';
			SUB_MENU_ITEM_BG_COLOR = '#34495e';
			TEXT_COLOR = '#f0f0f0';
			TEXT_COLOR_HOVER = '#000';
			break;
		case 'mode4':
			BACKGROUND_COLOR = '#5c5c5c';
			SUB_MENU_ITEM_BG_COLOR = '#6c757d';
			TEXT_COLOR = '#f0f0f0';
			TEXT_COLOR_HOVER = '#000';
			break;
		case 'mode5':
			BACKGROUND_COLOR = '#283149';
			SUB_MENU_ITEM_BG_COLOR = '#404b69';
			TEXT_COLOR = '#f0f0f0';
			TEXT_COLOR_HOVER = '#000';
			break;
		default:
			break;
	}

	return (
		<Sidebar
			backgroundColor={BACKGROUND_COLOR}
			width='300px'
			style={{
				height: '100vh',
				overflowX: 'hidden',
			}}
		>
			<div className='d-flex justify-content-center p-2 mt-4'>
				<div onClick={() => navigate('/')}>
					<img
						className='img-fluid'
						src={logo}
						alt='logo'
						width={280}
						height={150}
						style={{ cursor: 'pointer', marginTop: '40px' }}
					/>
				</div>
			</div>

			{/* Sidebar Container */}
			<div className='sidebar-container'>
				{/* Sidebar Header */}
				<div
					style={{
						position: 'absolute',
						top: 0,
						width: '100%',
					}}
				>
					{/* Boton ocultar */}
					<Menu
						menuItemStyles={{
							button: ({ level, active, disabled }) => {
								// only apply styles on first level elements of the tree
								if (level === 0)
									return {
										color: TEXT_COLOR,
										':hover': {
											backgroundColor: BACKGROUND_COLOR,
											color: TEXT_COLOR_HOVER,
										},
									};
							},
						}}
					>
						<MenuItem
							icon={
								collapsed ? <AiOutlineDoubleRight /> : <AiOutlineDoubleLeft />
							}
							onClick={() => {
								collapseSidebar();
							}}
						>
							Ocultar
						</MenuItem>
					</Menu>
				</div>

				<div className={`d-flex justify-content-start mt-4 ${collapsed ? 'clase-colapsada' : ''}`} style={{ marginLeft: '10%' }}>
					<p style={{ color: '#fff' }}>
						<i className={`fas fa-user ${collapsed ? 'icono-colapsado' : ''}`} /> &emsp; {getCapitalizedString(userObject.UserName)}
					</p>
				</div>
				{/* SidebarItems */}
				<div
					className='sidebar-items'
					style={{
						maxHeight: '60vh',
						overflowY: 'auto',
					}}
				>
					{/* Sidebar Menu Raiz */}
					<Menu
						menuItemStyles={{
							button: ({ level, active, disabled }) => {
								// only apply styles on first level elements of the tree
								if (level === 0)
									return {
										color: TEXT_COLOR,
										':hover': {
											backgroundColor: TEXT_COLOR,
											color: TEXT_COLOR_HOVER,
										},
									};
							},
						}}
					>
						<hr
							style={{
								color: TEXT_COLOR,
								height: 1,
							}}
						/>

						{loading ? (
							<div className='d-flex justify-content-center'>
								<ClipLoader color={TEXT_COLOR} />
							</div>
						) : (
							modules &&
							modules.map((module, submodule) => {
								return module.isSubmenu ? (
									<SubMenu
										rootStyles={{
											color: TEXT_COLOR,
											backgroundColor:
											selectedMenu === module.label ? BACKGROUND_COLOR : 'initial',
										}}
										icon={module.icon}
										key={module.label}
										label={module.label}
										onClick={() => {
											setSelectedMenu(module.label);
										}}
										>
										{module.items.map((submodule) => {
											const isSelected = selectedSubMenu === submodule.label;
											console.log('RENDER SubMenuItem:', submodule.label, 'path:', submodule.path);

											return (
											<MenuItem
												rootStyles={{
												'& > .ps-menu-button': {
													backgroundColor: isSelected ? '#fff' : '#0D5173',
													color: isSelected ? `${TEXT_COLOR_HOVER}!important` : '#fff',
													'&:hover': {
													backgroundColor: '#fff',
													color: '#000',
													},
												},
												}}
												key={submodule.label}
												icon={submodule.icon}
												component={<Link to={submodule.path} />}
												onClick={() => {
												setSelectedSubMenu(submodule.label);
												setSelectedMenu(module.label);
												}}
											>
												{submodule.label}
											</MenuItem>
											);
										})}
									</SubMenu>
								) : (
									<MenuItem
										key={module.label}
										icon={module.icon}
										component={<Link to={module.path} />}
										onClick={() => {
											setSelectedMenu(module.label);
											setSelectedSubMenu(null);
										}}
										className={selectedMenu === module.label ? 'selected-menu-item' : ''}
										style={{
											backgroundColor: selectedMenu === module.label ? 'white' : '',
											color: selectedMenu === module.label ? 'black' : '',
										}}
										>
										{module.label}
										{module.path === '/notifications' && numberUnseen > 0 && (
											<span className="badge num-notifications">
											{numberUnseen > 9 ? '9+' : numberUnseen}
											</span>
										)}
									</MenuItem>
								);
							})
						)}
						{/* <MenuItem
							rootStyles={{
								'& > .ps-menu-button': {
									backgroundColor: SUB_MENU_ITEM_BG_COLOR,
									color: TEXT_COLOR,
									'&:hover': {
										backgroundColor: TEXT_COLOR,
										color: TEXT_COLOR_HOVER,
									},
								},
							}}
							key='Notiftest'
							icon={<FaBell />}
							component={<Link to='/notifications' />}
						>
							Notiftest
							<span
								className='num-notifications'
							>
								9+
							</span>
						</MenuItem> */}
					</Menu>
				</div>

				{/* Sidebar Footer */}
				<div
					style={{
						bottom: 0,
						width: '100%',
					}}
				>
					<hr
						style={{
							color: TEXT_COLOR,
							height: 1,
						}}
					/>
					<Menu
						menuItemStyles={{
							button: ({ level, active, disabled }) => {
								// only apply styles on first level elements of the tree
								if (level === 0)
									return {
										color: TEXT_COLOR,
										':hover': {
											backgroundColor: TEXT_COLOR,
											color: TEXT_COLOR_HOVER,
									},
								};
							},
						}}
					>
						<MenuItem
							icon={<RiLockPasswordFill />}
							component={<Link to='/change-password' />}
							onClick={() => {
								setSelectedMenu('Cambiar contraseña'); // Ajusta el valor según el texto del ítem
								setSelectedSubMenu(null);
							}}
							className={selectedMenu === 'Cambiar contraseña' ? 'selected-menu-item' : ''}
							style={{
								backgroundColor: selectedMenu === 'Cambiar contraseña' ? 'white' : '',
								color: selectedMenu === 'Cambiar contraseña' ? 'black' : '',
							}}
							>
							Cambiar contraseña
						</MenuItem>
						<MenuItem
							icon={<FiLogOut className='fa-rotate-180' />}
							onClick={() => {
								ntfs.disconnect();
								ntfs.clearNotifications();
								signOut();
							}}
						>
							Cerrar Sesión
						</MenuItem>
					</Menu>
				</div>
			</div>
		</Sidebar>
	);
};

export default CollapsibleSidebar;
